import React from 'react';
import './../../../assets/css/Loader.css';
import { connect } from 'react-redux';
// import loading_audio from './../../../assets/sounds/loading.mp3'

const Loader = (props) => {
    const chars = ['H', 'R', 'D'];
    // const chars = ['I', 'N', 'C','R', 'E', 'M', 'E', 'N', 'T'];
    const PlaySound = () => {
        let audio = document.getElementById("audio");
        // audio.play();
    }
    const PauseSound = () => {
        let audio = document.getElementById("audio");
        // audio.stop();
    }
    if (props.showLoading) {
        PlaySound()
    } else {
        PauseSound();
    }
    return (
        <>
            {/* <audio id="audio">
                <source src={loading_audio} />
            </audio> */}
            {props.showLoading && <>
                <div className="loaderBody">
                    <div className="loader">
                        {chars.map((char, index) => (
                            <span key={index} style={{ '--i': index + 1 }}>{char}</span>
                        ))}
                    </div>
                </div>

            </>
            }

        </>
    );
};
const mapStateToProps = (state) => {
    return {
        showLoading: state.auth.showLoading,
    };
};
export default connect(mapStateToProps)(Loader);
